import * as React from "react";

interface WrapCodeProps {
  children?: React.ReactNode;
}

export function WrapCode(props: WrapCodeProps) {
  return <code className="text-break text-wrap">{props.children}</code>;
}
